import type { ReactElement } from 'react';
import { Check, ChevronRight } from 'lucide-react';
import { cn } from '@/lib/utils';

const STEPS = [
  { number: 1, label: 'Brand colour' },
  { number: 2, label: 'Logo' },
  { number: 3, label: 'Home page' },
  { number: 4, label: 'Domain' },
];

interface StepperBreadcrumbProps {
  activeStep: number;
}

export function StepperBreadcrumb({ activeStep }: StepperBreadcrumbProps): ReactElement {
  return (
    <nav
      aria-label="Onboarding progress"
      className="vtwo:flex vtwo:items-center vtwo:justify-center vtwo:gap-3 vtwo:flex-wrap"
    >
      {STEPS.map((step, i) => {
        const isCompleted = step.number < activeStep;
        const isActive = step.number === activeStep;

        return (
          <div key={step.number} className="vtwo:flex vtwo:items-center vtwo:gap-3">
            {i > 0 && <ChevronRight className="vtwo:size-4 vtwo:text-gray-400" />}

            <div className="vtwo:flex vtwo:items-center vtwo:gap-2">
              <div
                className={cn(
                  'vtwo:size-5 vtwo:rounded-full vtwo:flex vtwo:items-center vtwo:justify-center vtwo:text-xs vtwo:font-semibold vtwo:shrink-0',
                  isCompleted && 'vtwo:bg-green-800 vtwo:text-white',
                  isActive && 'vtwo:bg-featured vtwo:text-white',
                  !isCompleted && !isActive && 'vtwo:bg-gray-200 vtwo:text-gray-500'
                )}
              >
                {isCompleted ? <Check className="vtwo:size-3" /> : step.number}
              </div>

              <span
                className={cn(
                  'vtwo:text-sm vtwo:font-medium vtwo:uppercase vtwo:tracking-wide vtwo:whitespace-nowrap',
                  isCompleted && 'vtwo:text-green-800',
                  isActive && 'vtwo:text-featured',
                  !isCompleted && !isActive && 'vtwo:text-gray-400'
                )}
              >
                {step.label}
              </span>
            </div>
          </div>
        );
      })}
    </nav>
  );
}
